import * as angular from 'angular';
import { GradPlanningWizardDropdownComponent } from './grad-planning-wizard-dropdown.component';

export const GradPlanningWizardDropdownModule = angular
  .module('gradPlanningWizardDropdown', [])
  .component('gradPlanningWizardDropdown', GradPlanningWizardDropdownComponent).name;
